import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allMateriasAction } from '../MateriasAction';

const SelectFieldMateriasComponent = ({
  onChange,
  id = 'select-materias',
  data,
  value = '',
  isEmpty = false,
  isAll = true,
  selects = [],
  required = false,
  error = false,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const materiasStore = Redux.useSelector((state) => state.materias);

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && materiasStore.all.length === 0) {
        await allMateriasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
        setItems(materiasStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let items = [];
    if (selects.length > 0) {
      materiasStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(materiasStore.all);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selects]);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${id}`}>{CONST.materia.label}</InputLabel>
      <Select
        id={CONST.ID}
        value={value?.toString()}
        labelId={`label_${id}`}
        label={CONST.materia.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty ||
          (isAll && (
            <MenuItem key={`${id}-000-item`} value={null}>
              {isAll ? ' TODOS' : 'NINGUNO'}
            </MenuItem>
          ))}
        {items.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

SelectFieldMateriasComponent.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectFieldMateriasComponent;
